export default "__VITE_ASSET__YS1iIlD2__"